"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _text = _interopRequireDefault(require("@ux/text"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _headlineLockup = _interopRequireDefault(require("@site/pattern-library-core/headline-lockup"));
var _price = _interopRequireDefault(require("@site/pattern-library-core/price"));
var _listItem = _interopRequireDefault(require("./list-item"));
var _index = _interopRequireDefault(require("../../../experiments/animation/motion-move/index"));
var _scrollContext = require("../../../experiments/animation/motion-parallax/scroll-context");
var _decorImages = _interopRequireDefault(require("./decor-images"));
var _icon = require("@site/pattern-library-utils/icon");
var _actions = _interopRequireDefault(require("../../../elements/other/actions"));
var _boxModelSize = require("@site/pattern-library-utils/box-model-size");
var _base = require("@site/pattern-library-utils/base.functions");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable complexity */

const SectionContainer = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "SectionContainer",
  class: "pl-s1swq0uj"
});
const Group = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Group",
  class: "pl-g1b9peo5"
});
const SectionHeadline = /*#__PURE__*/(0, _react2.styled)(_index.default)({
  name: "SectionHeadline",
  class: "pl-s1sdvae3"
});
const Panels = /*#__PURE__*/(0, _react2.styled)(_index.default)({
  name: "Panels",
  class: "pl-p1r9ub1s"
});
const LeftPanel = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "LeftPanel",
  class: "pl-lz1o5ie"
});
const PriceContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "PriceContainer",
  class: "pl-ppxptv4"
});
const RightPanel = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "RightPanel",
  class: "pl-ry0gqcn"
});
const Title = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Title",
  class: "pl-tlxookd"
});
const ListContainer = /*#__PURE__*/(0, _react2.styled)(_index.default)({
  name: "ListContainer",
  class: "pl-l15dz5gb"
});
const AiroBanner = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "AiroBanner",
  class: "pl-acqpkch"
});
const Inner = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Inner",
  class: "pl-i12zoq3a"
});
const IconWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "IconWrapper",
  class: "pl-i16edi1u"
});
const ButtonWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ButtonWrapper",
  class: "pl-b15i1dr1"
});

/**
 * SinglePlanSection Component.
 *
 * @param {Object} props React props
 * @param {string} props.id ID of the section
 * @param {string} props._name Tracking name of the section
 * @param {string} props.sectionHeading heading for the section
 * @param {string} props.tagLabel tag label for the headline lockup
 * @param {React.ReactElement|object} props.headlineLockup node for headline lockup component
 * @param {string} props.heading heading text
 * @param {string} props.description description text
 * @param {string} props.headlineTag headline tag
 * @param {number} props.headlineLineLength headline line length
 * @param {Object} props.priceLockup price lockup
 * @param {Array|Object} props.ctas ctas
 * @param {string} props.listHeading heading for the list container
 * @param {Array} props.listItems list items
 * @param {string} props.verticalPadding vertical padding
 * @param {string} props.verticalMargin vertical margin
 * @param {Object} props.decorImage1 decor image 1
 * @param {Object} props.decorImage2 decor image 2
 * @param {Object} props.decorImage3 decor image 3
 * @param {Object} props.decorImageBg1 decor image bg 1
 * @param {Object} props.decorImageBg2 decor image bg 2
 * @param {string} props.layout layout of the section
 * @returns {React.ReactElement} SinglePlanSection Component
 * @public
 */

function SinglePlanSection({
  id,
  _name,
  layout = 'default',
  sectionHeading,
  tagLabel,
  labelDesign,
  heading,
  description,
  headlineTag,
  headlineLineLength,
  headlineLockup,
  priceLockup,
  ctas,
  listHeading,
  listItems,
  verticalPadding = 'large',
  verticalMargin = 'medium',
  decorImage1,
  decorImage2,
  decorImage3,
  decorImageBg1,
  decorImageBg2,
  panelBannerIcon,
  panelBannerText,
  disclaimerItems,
  oversizedPrice = false
}) {
  const isMini = layout === 'mini';
  const headlineLockupCtas = /*#__PURE__*/_react.default.isValidElement(headlineLockup) && headlineLockup.props.ctas ? headlineLockup.props.ctas : null;
  const ctasToRender = headlineLockupCtas || ctas;
  const headlineLockupComponent = (0, _react.useMemo)(() => {
    if (/*#__PURE__*/_react.default.isValidElement(headlineLockup)) {
      return /*#__PURE__*/_react.default.cloneElement(headlineLockup, {
        headlineSize: headlineLockup.props.headlineSize || (isMini ? 'h1' : 'd3'),
        textAlign: headlineLockup.props.textAlign || 'start',
        className: `panel-heading ${headlineLockup.props.className || ''}`,
        ctas: null
      });
    }
    return /*#__PURE__*/_react.default.createElement(_headlineLockup.default, {
      className: "panel-heading",
      headlineSize: isMini ? 'h1' : 'd3',
      textAlign: "start",
      tagLabel,
      labelDesign,
      heading,
      description,
      headlineLineLength,
      headlineTag
    });
  }, [headlineLockup, isMini, tagLabel, labelDesign, heading, description, headlineLineLength, headlineTag]);
  return /*#__PURE__*/_react.default.createElement(_scrollContext.ScrollProvider, null, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      overflowX: 'hidden'
    }
  }, /*#__PURE__*/_react.default.createElement(SectionContainer, {
    id: `id-${id}`,
    _name: _name,
    dataCy: "single-plan-section",
    verticalPadding: verticalPadding,
    verticalMargin: verticalMargin
  }, /*#__PURE__*/_react.default.createElement(Group, null, sectionHeading && /*#__PURE__*/_react.default.createElement(SectionHeadline, {
    mode: "fluid",
    intensity: "300",
    variant: "moveUpFixed",
    triggerOnce: true,
    dataCy: "section-heading"
  }, /*#__PURE__*/_react.default.createElement(_text.default.h2, {
    as: "heading",
    size: 5,
    className: "section-heading",
    text: sectionHeading
  })), /*#__PURE__*/_react.default.createElement(_decorImages.default, {
    decorImage1: decorImage1,
    decorImage2: decorImage2,
    decorImage3: decorImage3,
    decorImageBg1: decorImageBg1,
    decorImageBg2: decorImageBg2
  }), /*#__PURE__*/_react.default.createElement(Panels, {
    mode: "fluid",
    variant: "moveUpFixed",
    intensity: "300",
    triggerOnce: true,
    className: isMini && 'layout-mini',
    dataCy: "panels"
  }, /*#__PURE__*/_react.default.createElement(LeftPanel, {
    "data-partial": "light1"
  }, panelBannerText && /*#__PURE__*/_react.default.createElement(AiroBanner, {
    "data-partial": "dark1"
  }, panelBannerIcon && /*#__PURE__*/_react.default.createElement(IconWrapper, null, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: panelBannerIcon
  })), panelBannerText && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    size: 1,
    text: panelBannerText
  })), /*#__PURE__*/_react.default.createElement(Inner, {
    className: isMini && 'layout-mini'
  }, headlineLockupComponent, /*#__PURE__*/_react.default.createElement(PriceContainer, {
    className: `${oversizedPrice ? 'oversized-price' : ''} ${isMini ? 'layout-mini' : ''}`.trim()
  }, priceLockup && /*#__PURE__*/_react.default.createElement(_price.default, (0, _extends2.default)({
    strikeThroughPriceEnd: oversizedPrice
  }, priceLockup)), /*#__PURE__*/_react.default.createElement(ButtonWrapper, {
    className: isMini && 'layout-mini'
  }, ctasToRender && /*#__PURE__*/_react.default.createElement("div", {
    className: "cta-container",
    "data-cy": "ctas"
  }, Array.isArray(ctasToRender) ? /*#__PURE__*/_react.default.createElement(_actions.default, {
    actionsLayout: "button-set",
    ctas: ctasToRender?.map(cta => ({
      ...cta,
      shrinkOn: 'tabletLg',
      width: 'full'
    }))
  }) : ctasToRender), disclaimerItems?.length > 0 && disclaimerItems.map((item, index) => /*#__PURE__*/_react.default.createElement("span", {
    key: index,
    "data-cy": "disclaimer-item"
  }, /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    size: -2,
    "data-cy": "button-disclaimer",
    text: item.text
  }))))))), /*#__PURE__*/_react.default.createElement(RightPanel, {
    className: isMini && 'layout-mini',
    "data-partial": "dark1"
  }, /*#__PURE__*/_react.default.createElement(Title, null, listHeading && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "title",
    size: -2,
    text: listHeading,
    "data-cy": "list-heading"
  })), /*#__PURE__*/_react.default.createElement(ListContainer, {
    mode: "fluid",
    intensity: "100",
    variant: "appear",
    staggerChildren: true,
    intensityMultiplier: 12,
    triggerOnce: true
  }, listItems?.map((item, index) => /*#__PURE__*/_react.default.createElement(_listItem.default, {
    key: index,
    image: item.image,
    icon: item.icon,
    title: item.title,
    description: item.description,
    className: isMini && 'layout-mini'
  })))))))));
}
var _default = exports.default = SinglePlanSection;
SinglePlanSection.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  layout: _propTypes.default.oneOf(['default', 'mini']),
  sectionHeading: _propTypes.default.string,
  tagLabel: _propTypes.default.string,
  labelDesign: _propTypes.default.string,
  heading: _propTypes.default.string,
  description: _propTypes.default.string,
  headlineTag: _propTypes.default.string,
  headlineLineLength: _propTypes.default.number,
  headlineLockup: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.element]),
  textAlign: _propTypes.default.string,
  priceLockup: _propTypes.default.object,
  ctas: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.object]),
  listHeading: _propTypes.default.string,
  listItems: _propTypes.default.array,
  decorImage1: _propTypes.default.object,
  decorImage2: _propTypes.default.object,
  decorImage3: _propTypes.default.object,
  decorImageBg1: _propTypes.default.object,
  decorImageBg2: _propTypes.default.object,
  panelBannerIcon: _propTypes.default.string,
  panelBannerText: _propTypes.default.string,
  disclaimerItems: _propTypes.default.array,
  oversizedPrice: _propTypes.default.bool,
  ..._boxModelSize.marginProps,
  ..._boxModelSize.paddingProps
};